<template>
  <div class="panel-topnav container-fluid">
    <a class="hidden back-link pull-left" href="">
      <i class="ion-ios-arrow-back text-yellow before"></i> Projects
    </a>
    <el-menu
      class="el-menu-demo flex-1 mb-6"
      mode="horizontal"
      :default-active="activeIndex"
    >
      <el-menu-item index="companies">
        <router-link
          class="inline-block link-no-underline"
          :to="{ name: 'dashboardStartupList' }"
        >
          Companies
        </router-link>
      </el-menu-item>
      <el-menu-item
        v-if="$hasFeature('ORG_NEW_STARTUPS') && user.canSeeStartupList"
        index="new_companies"
      >
        <router-link
          class="inline-block link-no-underline"
          :to="{ name: 'dashboardNewStartupList' }"
        >
          New Companies
        </router-link>
      </el-menu-item>
      <el-menu-item v-if="user.organizationId" index="featured">
        <router-link
          class="inline-block link-no-underline"
          :to="{ name: 'dashboardFeaturedStartups' }"
        >
          Featured
        </router-link>
      </el-menu-item>
      <el-menu-item index="shortlists">
        <router-link
          class="inline-block link-no-underline"
          :to="{ name: 'shortlistListPage' }"
        >
          Shortlists
        </router-link>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import useUser from 'states/useUser'
import { computed } from '@vue/composition-api'
import router from '@/routes'

export default {
  setup() {
    const { user } = useUser()
    const routeMapping = {
      dashboardStartupList: 'companies',
      dashboardNewStartupList: 'new_companies',
      dashboardFeaturedStartups: 'featured',
      shortlistListPage: 'shortlists',
      shortlistDetailsPage: 'shortlists',
    }

    const activeIndex = computed(() => {
      return routeMapping[router.currentRoute.name]
    })
    return {
      user,
      activeIndex,
    }
  },
}
</script>
